import React, { useState } from "react";
import cn from "classnames";
import styles from "./SignQrCode.module.sass";
import Card from "../Card";
import Icon from "../Icon";
import ModalQrCode from "../ModalQrCode";

const SignQrCode = ({ className, session }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleGenerateQrCode = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Card
        className={cn(className)}
        title="QR Code"
        classTitle="title-green"
      >
        <div className={styles.item}>
          <div className={styles.icon} style={{ backgroundColor: "#000000" }}>
            <Icon name="qr-code" size="24" fill="#FFFFFF" />
          </div>
          <div className={styles.content}>
            <h3>Pointage par QR Code</h3>
            <p>Session : <strong>{session?.title || "Non définie"}</strong></p>
            <p>Les étudiants peuvent scanner le QR code pour pointer automatiquement leur présence.</p>
          </div>
        </div>
        <button className={styles.button} onClick={handleGenerateQrCode}>
          Générer QR Code
        </button>
      </Card>

      <ModalQrCode
        visible={isModalVisible}
        onClose={handleCloseModal}
        session={session}
      />
    </>
  );
};

export default SignQrCode;
